export default __webpack_public_path__ + "static/media/client4.ed59b05e.png";